import { Box, Chip, IconButton, Paper, Skeleton, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';

import { InProgressAnnotationCard } from './InProgressAnnotationCard';
import { Annotation } from '../../../../../workspace-common/types/responseTypes';
import { ReferenceTextSection } from '../ReferenceTextSection';

interface InEditAnnotationCardOuterProps {
  annotation: Annotation;
  conceptId: string;
  annotationNumber: number;
  onDelete: (e: React.MouseEvent<HTMLButtonElement>, annotationId: string) => void;
  isDeleteResolvedAnnotationLoading: boolean;
}

export const InEditAnnotationCardOuter = ({
  annotation,
  conceptId,
  annotationNumber,
  onDelete,
  isDeleteResolvedAnnotationLoading,
}: InEditAnnotationCardOuterProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  if (isDeleteResolvedAnnotationLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
          width: '100%',
          border: `1px solid ${theme.palette.divider}`,
          p: theme.spacing(4),
        }}
      >
        <Skeleton variant="text" width="100%" height="100px" />
      </Box>
    );
  }
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 0,
        padding: theme.spacing(4),
        gap: theme.spacing(4),
        border: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(3) }}>
          <Typography variant="body1">
            {formatMessage(
              { id: 'supervisorReview.tab.annotationCount' },
              { count: annotationNumber }
            )}
          </Typography>
          <Chip
            variant="filled"
            sx={{
              backgroundColor: theme.palette.grey[300],
              size: 'small',
              fontSize: '13px',
            }}
            label={formatMessage({ id: 'supervisorReview.tab.inProgress.chip.title' })}
          />
          {(annotation?.spans.length ?? 0) === 0 && (
            <ReferenceTextSection referenceText={annotation?.referenceText} />
          )}
        </Box>
        {/* Dont show delete icon in case of edit mode */}
        {/* <Box>
                    <IconButton onClick={(e)=>onDelete(e, annotationId)}>
                        <Icon id={`delete-resolved-${annotation.annotationId}`} icon='delete' width={19} height={19}/>
                    </IconButton>
                </Box> */}
      </Box>
      <InProgressAnnotationCard annotation={annotation} conceptId={conceptId} />
    </Paper>
  );
};
